// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    /* 垂直置中子元素 */
    /* background-color: #f8f9fa; */
    /* 可選，設定背景色 */
}

/* 父容器的 Grid 佈局，使用 2:6:2 比例 */
.player-container {
    display: grid;
    grid-template-columns: 3fr 5.5fr 3fr;
    width: 90%;
    height: 100%;
    /* 左中右 2:6:2 的比例 */

    background-color: rgba(255, 255, 255, 0.85);
    border-radius: 5px;
    border: 2.5px solid rgba(0, 0, 0, 0.9);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.5);

}

/* 左側按鈕容器 */
.left-buttons-container {
    display: flex;
    /* 水平排列 */
    align-items: center;
    /* 垂直置中 */
    justify-content: center;
    /* 靠左對齊 */
    gap: 5px;
    /* 按鈕之間的間距 */
}



.right-buttons-container {
    display: flex;
    align-items: center;
    justify-content: center;
    /* 元素水平居中排列 */
    gap: 20px;
    height: 100%;
}


/* 中間進度條容器 */
.progress-wrapper {
    flex-direction: column;
    /* 垂直排列 */
    justify-content: center;
    /* 垂直置中 */
    align-items: center;
    margin-top: 10px;
    /* 容器本身向下內縮 */
}

.progress-LabelsRow {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 100%;
    font-family: 'San Francisco', Tahoma, Geneva, sans-serif;
    font-size: 16px;
    color: #000000;
}

#trackNameLabel {
    font-size: 18px;
}

/* noUiSlider 進度條 */
.progress-bar {
    position: relative;
}

/* 隱藏拖曳物件 */
#progressBar .noUi-handle {
    display: none;
}

/* 播放過的部分設置為灰色 */
#progressBar .noUi-connect {
    background: #cccccc;
}

#progressBar .noUi-target {
    background: #e0e0e0;
    height: 8px;
    border-radius: 10px;
}

#progressBar .noUi-pips {
    color: #999;
}


.volume-controller {
    grid-column: 3;
    /* 放在右邊的網格區域 */
    width: 100px;
    height: 80%;
    margin: 10px 0;
}

/* 拖曳物件的樣式設計 */

#volumeController .noUi-origin {
    z-index: 10;
}

#volumeController .noUi-handle {
    position: absolute;
    transform: translate(-23%, -50%);
    /* 水平與垂直置中 */
    width: 20px;
    height: 12px;
}

#volumeController .noUi-handle::before,
#volumeController .noUi-handle::after {
    content: "";
    /* 清空内容 */
    display: none;
    /* 隐藏伪元素 */
}

#volumeController .noUi-connect {
    background: #80bc8d;
}`, "",{"version":3,"sources":["webpack://./src/styles/footer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;IAC/B,aAAa;AACjB;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,oCAAoC;IACpC,UAAU;IACV,YAAY;IACZ,kBAAkB;;IAElB,2CAA2C;IAC3C,kBAAkB;IAClB,sCAAsC;IACtC,yCAAyC;;AAE7C;;AAEA,WAAW;AACX;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,SAAS;IACT,QAAQ;IACR,YAAY;AAChB;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,SAAS;IACT,YAAY;AAChB;;;AAGA,YAAY;AACZ;IACI,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,WAAW;IACX,wDAAwD;IACxD,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;AACtB;;AAEA,WAAW;AACX;IACI,aAAa;AACjB;;AAEA,gBAAgB;AAChB;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,cAAc;IACd,cAAc;IACd,YAAY;IACZ,WAAW;IACX,cAAc;AAClB;;AAEA,cAAc;;AAEd;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,SAAS;IACT,aAAa;IACb,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".app-footer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /* 垂直置中子元素 */\n    /* background-color: #f8f9fa; */\n    /* 可選，設定背景色 */\n}\n\n/* 父容器的 Grid 佈局，使用 2:6:2 比例 */\n.player-container {\n    display: grid;\n    grid-template-columns: 3fr 5.5fr 3fr;\n    width: 90%;\n    height: 100%;\n    /* 左中右 2:6:2 的比例 */\n\n    background-color: rgba(255, 255, 255, 0.85);\n    border-radius: 5px;\n    border: 2.5px solid rgba(0, 0, 0, 0.9);\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.5);\n\n}\n\n/* 左側按鈕容器 */\n.left-buttons-container {\n    display: flex;\n    /* 水平排列 */\n    align-items: center;\n    /* 垂直置中 */\n    justify-content: center;\n    /* 靠左對齊 */\n    gap: 5px;\n    /* 按鈕之間的間距 */\n}\n\n\n\n.right-buttons-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    /* 元素水平居中排列 */\n    gap: 20px;\n    height: 100%;\n}\n\n\n/* 中間進度條容器 */\n.progress-wrapper {\n    flex-direction: column;\n    /* 垂直排列 */\n    justify-content: center;\n    /* 垂直置中 */\n    align-items: center;\n    margin-top: 10px;\n    /* 容器本身向下內縮 */\n}\n\n.progress-LabelsRow {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    width: 100%;\n    font-family: 'San Francisco', Tahoma, Geneva, sans-serif;\n    font-size: 16px;\n    color: #000000;\n}\n\n#trackNameLabel {\n    font-size: 18px;\n}\n\n/* noUiSlider 進度條 */\n.progress-bar {\n    position: relative;\n}\n\n/* 隱藏拖曳物件 */\n#progressBar .noUi-handle {\n    display: none;\n}\n\n/* 播放過的部分設置為灰色 */\n#progressBar .noUi-connect {\n    background: #cccccc;\n}\n\n#progressBar .noUi-target {\n    background: #e0e0e0;\n    height: 8px;\n    border-radius: 10px;\n}\n\n#progressBar .noUi-pips {\n    color: #999;\n}\n\n\n.volume-controller {\n    grid-column: 3;\n    /* 放在右邊的網格區域 */\n    width: 100px;\n    height: 80%;\n    margin: 10px 0;\n}\n\n/* 拖曳物件的樣式設計 */\n\n#volumeController .noUi-origin {\n    z-index: 10;\n}\n\n#volumeController .noUi-handle {\n    position: absolute;\n    transform: translate(-23%, -50%);\n    /* 水平與垂直置中 */\n    width: 20px;\n    height: 12px;\n}\n\n#volumeController .noUi-handle::before,\n#volumeController .noUi-handle::after {\n    content: \"\";\n    /* 清空内容 */\n    display: none;\n    /* 隐藏伪元素 */\n}\n\n#volumeController .noUi-connect {\n    background: #80bc8d;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
